var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex flex-row align-baseline" },
        [
          _c(
            "v-btn",
            {
              staticClass: "ma-4",
              attrs: {
                color: "accent",
                disabled: !_vm.hasChanges || _vm.isManagingCharacter,
                loading: _vm.isSavingChanges,
                outlined: "",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("save-changes")
                },
              },
            },
            [_vm._v(_vm._s(_vm.day6Resource.save))]
          ),
          _c(
            "v-btn",
            {
              staticClass: "ma-4",
              attrs: {
                color: "accent",
                disabled: _vm.isManagingCharacter,
                outlined: "",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("new-character")
                },
              },
            },
            [_vm._v(_vm._s(_vm.dataBrowserResource.new))]
          ),
          _vm.mainMessage
            ? _c("p", { staticClass: "body-1 mb-0" }, [
                _vm._v(_vm._s(_vm.mainMessage)),
              ])
            : _vm._e(),
          _c("div", { staticClass: "flex-grow-1" }),
          _vm.isSmallScreen
            ? _c(
                "v-btn",
                {
                  staticClass: "ma-4",
                  attrs: { color: "accent", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close-browser")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.commonResource.close))]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "virtual-list",
        {
          staticClass: "list-container",
          style: { height: _vm.listHeight + "px" },
          attrs: {
            "data-key": "id",
            "data-sources": _vm.itemData,
            "data-component": _vm.ListItem,
          },
          on: {
            tobottom: _vm.onScrollToBottom,
            "on-press-item": _vm.onItemPress,
            "on-edit-item": _vm.onEditCharacterData,
            "on-move-item-top": _vm.onItemMoveTop,
            "on-delete-item": _vm.onItemDelete,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.isListLoading
                ? _c("v-progress-circular", {
                    staticClass: "center-loading-indicator",
                    attrs: {
                      color: _vm.loadingIndicatorUi.color,
                      width: _vm.loadingIndicatorUi.size,
                      indeterminate: "",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "800",
            fullscreen: _vm.isSmallScreen,
            "hide-overlay": _vm.isSmallScreen,
          },
          model: {
            value: _vm.showEditDialog,
            callback: function ($$v) {
              _vm.showEditDialog = $$v
            },
            expression: "showEditDialog",
          },
        },
        [
          _c("CharacterDataEditor", {
            ref: "dataEditor",
            attrs: {
              editingData: _vm.editingData,
              "disable-name-input": _vm.disableInput.name,
              "disable-sharing": _vm.disableInput.share,
              "disable-notes-input": _vm.disableInput.notes,
            },
            on: {
              "editor-action": _vm.onEditorAction,
              "name-change": _vm.updateCharacterName,
              "share-change": _vm.updateCharacterSharing,
              "notes-change": _vm.updateCharacterNotes,
            },
          }),
        ],
        1
      ),
      _c("FullDialog", {
        ref: "fullDialog",
        on: { "dialog-action": _vm.onDialogAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }